module.exports = __webpack_public_path__ + "static/media/headshot.f09f5b70.jpg";